/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Input from '@cashew/input';
import Button from '@cashew/button';
import { useEnterListener } from '@cashew/hooks';
import { useTranslation } from 'react-i18next';
import { MerchantData } from '../MerchantOnboarding/util';
import './index.css';
import ExportModal from './ExportModal';
import SelectComponent from '../../components/SelectComponent';

const { api } = require('@cashew/utils');

const numericInput = /^[0-9]+$/;

export default ({
  setLoading,
  useSelector,
  setRecords,
  setList,
  pageSize,
  pageNumber,
  dispatch,
  setPageNumber,
  type,
  records,
  history,
}: any) => {
  const { t } = useTranslation();
  const { token } = useSelector((state: any) => state.user);
  const [searchId, setSearchId] = useState('');
  const [searchBy, setSearchBy] = useState<string>('merchantName');
  const [filterParams, setFilterParams] = useState();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [enterBtn, setEnterBtn] = useState(false);

  interface MerchantsResponse {
    status: string;
    data: MerchantData[];
    totalCount: number;
  }

  const searchByData = [
    {
      key: 'merchantId',
      value: 'Merchant ID',
    },
    {
      key: 'merchantName',
      value: 'Merchant name',
    },
    {
      key: 'phoneNumber',
      value: 'Phone number',
    },
    {
      key: 'email',
      value: 'Email',
    },
  ];

  const getOrdersApi = (resetPageNumber = true) => {
    setLoading(true);

    if (resetPageNumber && pageNumber !== 0) {
      setPageNumber(0);
      return;
    }

    const params: any = {
      page: pageNumber,
      size: pageSize,
    };
    if (searchId && searchBy) {
      params[searchBy] = searchId.trim();
    }
    setFilterParams(params);
    api
      .get({
        endpoint: 'identity/merchants',
        params,
        headers: {
          Authorization: token,
        },
      })
      .then((resp: MerchantsResponse) => {
        setList(resp.data);
        setRecords(resp.totalCount);
      })
      .catch(() =>
        dispatch({
          type: 'OPEN_TOASTER',
          payload: {
            toasterTitle: t('dispatches.error.fetchingList.title'),
            toasterMessage: t('dispatches.error.fetchingList.message'),
            toasterType: 'error',
            toasterVisible: true,
            toasterDismiss: null,
          },
        })
      )
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setSearchId('');
  }, [searchBy]);

  useEnterListener(() => setEnterBtn((prev) => !prev));

  useEffect(() => {
    getOrdersApi(false);
  }, [pageNumber, pageSize, enterBtn]);

  const getExcelReport = () => {
    api
      .get({
        endpoint: 'identity/merchants/excel',
        responseType: 'blob',
        params: filterParams,
        headers: {
          Authorization: token,
        },
      })
      .then((response: any) => {
        const [firstDate, secondDate] = new Date()
          .toLocaleString('no-nb')
          .split(',');
        const name = [
          ...firstDate.split('/'),
          ...secondDate.trim().split(':'),
        ].join('-');
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        const blob = response;
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `Merchants_report_${name}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="filters">
        <div className="filter-group">
          <div className="filter-input">
            <SelectComponent
              label="Search by"
              data={searchByData}
              selected={searchBy}
              onSelect={setSearchBy}
            />
          </div>
          <div className="filter-input">
            <Input
              name="orderId"
              value={searchId}
              type="text"
              maxLength={searchBy === 'orderId' ? 14 : 100}
              onChange={(e: any) => {
                const searchValue = e.target.value;
                if (searchBy === 'merchantId') {
                  if (searchValue.match(numericInput) || searchValue === '') {
                    setSearchId(searchValue);
                  }
                } else {
                  setSearchId(searchValue);
                }
              }}
            />
          </div>
          <div className="filter-input">
            <button
              type="button"
              className="btn blue"
              onClick={() => {
                getOrdersApi();
              }}
            >
              Search
            </button>
          </div>
        </div>
        <div className="filter-group">
          {type === 'cashew' && (
            <div className="filter-input">
              <Button
                extraClass={records ? 'btn blue' : ''}
                disabled={!records}
                onClick={() => setShowCancelModal(true)}
              >
                Export to Excel
              </Button>
            </div>
          )}
        </div>
      </div>
      {type === 'cashew' && (
        <ExportModal
          showConfirmModal={showCancelModal}
          setShowConfirmModal={setShowCancelModal}
          token={token}
          history={history}
          dispatch={dispatch}
          getExcelReport={getExcelReport}
          records={records}
        />
      )}
    </>
  );
};
